<h1 mat-dialog-title *ngIf="EditForm==true">Edit Form</h1>
<h1 mat-dialog-title *ngIf="EditForm!=true">Edit Form Category</h1>

<div mat-dialog-content style="display: flex;flex-direction: column;">

  <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;" class="get-label">Name</mat-label>
    <input style="width: 500px;" type="text" matInput placeholder="Name" [(ngModel)]="Name" class="get-Input">
  </div>

  <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;" class="get-label">Description</mat-label>
    <input style="width: 500px;" type="text" matInput placeholder="Description" [(ngModel)]="Description"
      class="get-Input">
  </div>

  <div  *ngIf="EditForm == false" class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;" class="get-label">Date Duration </mat-label> 
    <input style="width: 500px;margin-left: 1%;" type="text" matInput placeholder="Enter Value (Days)" [(ngModel)]="DaysCount"
      class="get-Input">
      <i  class="material-icons button__icon"
      style="cursor: pointer;margin-left: 20px;" 
      title="This flows through to the “Search Digital Forms” Screen">info</i>
    </div>

  <div *ngIf="EditForm == true" class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;" class="get-label">Uploaded file</mat-label>
    <div><span>{{Filename}}</span></div>
  </div>

  <div *ngIf="EditForm==true" class="example-full-width" style="width: 500px;display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;margin-top: 12px;">
      <mat-label style="font-weight: bold;">Pick a different file</mat-label>
      <div >
        <label>
          <input type="file" name="upload" accept="application/pdf,application/vnd.ms-excel" (change)="onFileChanged($event);">
        </label>

      </div>


    </div>

</div>

<div mat-dialog-actions class="dialogControllBtn">
  <a class="button button--primary" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
  <button [disabled]="Name == ''"  style="margin-left: 20px;" class="button button--primary" (click)="onSubmitClick()" [disabled]="Name == null"
    cdkFocusInitial><span class="button__text">Submit</span></button>
</div>